import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "shards-react";

const PlainLayout = ({ children, noNavbar, noFooter }) => (
  <div>
        {children}      
  </div>
);

PlainLayout.propTypes = {
  /**
   * Whether to display the navbar, or not.
   */
  noNavbar: PropTypes.bool,
  /**
   * Whether to display the footer, or not.
   */
  noFooter: PropTypes.bool
};

PlainLayout.defaultProps = {
  noNavbar: false,
  noFooter: false
};

export default PlainLayout;
